module.exports = __webpack_public_path__ + "46b1171894e538cbf323e11d2e4c77cb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_bg.png
// module id = 279
// module chunks = 0